import * as e from '@/api/utils/endpoints'
import axios from '@/plugins/axios'

export const fetchAppVersion = () => axios.get(e.VERSION)
